import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/lib/auth/auth-client";
import Page from "@/pages/branding-gallery";

export const Route = createFileRoute("/branding-gallery")({
  head: () => ({
    meta: [
      { title: "Branding Reference Gallery | Digitally Baffled" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <ProtectedRoute requireAdmin>
      <Page />
    </ProtectedRoute>
  ),
});
